import React, { useState } from 'react';
import { Modal, Input, Button } from 'antd';
import { SearchOutlined, UserOutlined, CloseOutlined } from '@ant-design/icons';
import styles from './reassign-modal.module.scss';

export const ReassignModal = ({ isVisible, onClose, handleAssignment, selectedRowKeys = [], teamMembers = [] }) => {
  const [searchText, setSearchText] = useState('');
  const [selectedTeamMember, setSelectedTeamMember] = useState(null);

  const onSubmitAssignment = async () => {
    handleAssignment(selectedTeamMember);
    resetAndClose();
  };

  const resetAndClose = () => {
    setSearchText('');
    setSelectedTeamMember(null);
    onClose();
  };

  const filteredTeamMembers = teamMembers.filter(
    (member) =>
      member.first_name?.toLowerCase().includes(searchText.toLowerCase()) ||
      member.last_name?.toLowerCase().includes(searchText.toLowerCase()) ||
      member.email?.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <Modal
      title={
        <div className={styles.modalTitle}>
          <UserOutlined className={styles.titleIcon} />
          <span>Reassign Lead{selectedRowKeys?.length > 1 && 's'}</span>
        </div>
      }
      open={isVisible}
      onCancel={resetAndClose}
      footer={null}
      closeIcon={<CloseOutlined />}
      width={450}
      className={styles.reassignModal}>
      <div className={styles.modalContent}>
        <h4 className={styles.searchTitle}>Search Team Members</h4>
        <div className={styles.searchContainer}>
          <Input
            placeholder="Search by name or email..."
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className={styles.searchInput}
          />
        </div>
        <div className={styles.teamMembersList}>
          {filteredTeamMembers.map((member) => (
            <div
              key={member.user_id}
              className={`${styles.teamMemberItem} ${selectedTeamMember === member.user_id ? styles.selected : ''}`}
              onClick={() => setSelectedTeamMember(member.user_id)}>
              <div className={styles.memberName}>
                {member.first_name} {member.last_name}
              </div>
              <div className={styles.memberEmail}>{member.email}</div>
            </div>
          ))}
          {filteredTeamMembers.length === 0 && <div className={styles.noResults}>No team members found</div>}
        </div>
        <div className={styles.modalFooter}>
          <Button onClick={resetAndClose} className={styles.cancelButton}>
            Cancel
          </Button>
          <Button
            type="primary"
            onClick={onSubmitAssignment}
            disabled={!selectedTeamMember}
            className={styles.reassignButton}>
            Reassign Lead{selectedRowKeys?.length > 1 && 's'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
